const ContactText =
  "Remas DOO \nAddress: Gagarinova 8, Novi Sad \n Identification number: 21721824 \n Tax ID: 110526348 \n Email: remasdoo@outlook.com";

export default ContactText;
